import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, reduxForm } from 'redux-form';
import styled from 'styled-components/macro';

import InputGroup from '../InputGroup';
import Button from '../Button';
import TwoGroup from '../TwoGroup';
import DropDownSelect from '../DropDownSelect';
import CheckboxGroup from '../CheckboxGroup';

import {
    Container,
    ButtonGroupWrapper,
    MultipleGroupWrapper,
    MultipleGroupLast,
    MultipleGroupHalf,
    OnSubmitValidator
} from '../../containers/DefaultStyles/FormDetails';

import {
    getCachedFirstName,
    getCachedMiddleName,
    getCachedLastName
} from '../../utils/formCaching/helpers';
import submissionErrorHandler from '../../utils/submissionErrorHandler';
import { validateStep1 as validate } from './validations';

const MultipleGroupWrapperFullRowMobile = styled(MultipleGroupWrapper)`
    @media (max-width: 30em) {
        flex-wrap: wrap;

        .fullRowMobile {
            width: calc(100% - 1em);
            flex: none;
            margin-top: 0.75em;
        }
    }
`;

class VoteRegistrationStep1Form extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            class: 'default',
            errors: submissionErrorHandler(props.currentFormValues, validate)
        };
        this.handleChange = this.handleChange.bind(this);
        this.clearSubmitErrors = this.clearSubmitErrors.bind(this);
    }

    handleChange() {
        this.setState({ class: 'changed' });
    }

    componentDidMount() {
        this.setState({ errors: [] });
    }

    setSubmitErrors(errors) {
        this.setState({ errors });
    }

    checkForBlurError(name) {
        const errors = submissionErrorHandler(this.props.currentFormValues, validate);
        if (errors.includes(name) && !this.state.errors.includes(name))
            this.setState({ errors: [...this.state.errors, name] });
    }

    clearSubmitErrors(fieldName) {
        if (fieldName && this.state.errors.includes(fieldName)) {
            this.setState({ errors: this.state.errors.filter(e => e !== fieldName) });
        }
    }

    render() {
        return (
            <Container autocomplete="on" onSubmit={this.props.handleSubmit}>
                <MultipleGroupWrapperFullRowMobile>
                    <Field
                        name="prefix"
                        onBlur={() => this.checkForBlurError('prefix')}
                        submissionError={this.state.errors.includes('prefix')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={DropDownSelect}
                        options={this.props.prefix}
                        defaultOption={'Choose'}
                        label="Prefix"
                        type="text"
                    />
                    <Field
                        name="firstName"
                        onBlur={() => this.checkForBlurError('firstName')}
                        submissionError={this.state.errors.includes('firstName')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="First name"
                        placeholder="First Name"
                        autocomplete="off"
                    />
                    <Field
                        name="middleName"
                        component={InputGroup}
                        type="text"
                        label="Middle name"
                        placeholder="Middle Name"
                        autocomplete="off"
                    />
                </MultipleGroupWrapperFullRowMobile>
                <MultipleGroupLast>
                    <Field
                        name="lastName"
                        onBlur={() => this.checkForBlurError('lastName')}
                        submissionError={this.state.errors.includes('lastName')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="text"
                        label="Last name"
                        placeholder="Last Name"
                        autocomplete="off"
                    />
                    <Field
                        name="suffix"
                        component={DropDownSelect}
                        options={this.props.suffix}
                        label="Suffix"
                        type="text"
                    />
                </MultipleGroupLast>
                <MultipleGroupHalf>
                    <Field
                        name="email"
                        onBlur={() => this.checkForBlurError('email')}
                        submissionError={this.state.errors.includes('email')}
                        clearSubmitErrors={this.clearSubmitErrors}
                        component={InputGroup}
                        type="email"
                        label="Email"
                        placeholder="Email"
                        autocomplete="off"
                    />
                </MultipleGroupHalf>
                <MultipleGroupHalf>
                    <Field
                        name="usCitizen"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="I am a us citizen"
                        normalize={v => !!v}
                    />
                    <Field
                        name="hasStateLicense"
                        defaultChecked={true}
                        component={CheckboxGroup}
                        label="I have a state issued ID"
                        normalize={v => !!v}
                    />
                </MultipleGroupHalf>
                <ButtonGroupWrapper>
                    <TwoGroup>
                        <Button label="Back" onClick={this.props.onBack} />
                        <OnSubmitValidator
                            onClick={e => {
                                e.preventDefault();
                                const errors = submissionErrorHandler(
                                    this.props.currentFormValues,
                                    validate
                                );
                                if (errors.length === 0 && !this.props.invalid) {
                                    this.props.handleSubmit();
                                    this.props.onContinue();
                                } else {
                                    this.setSubmitErrors(errors);
                                }
                            }}
                        >
                            <Button
                                primary={true}
                                type="submit"
                                label="Continue"
                                disabled={this.props.invalid}
                            />
                        </OnSubmitValidator>
                    </TwoGroup>
                </ButtonGroupWrapper>
            </Container>
        );
    }
}

VoteRegistrationStep1Form.propTypes = {
    currentFormValues: PropTypes.object,
    handleSubmit: PropTypes.func,
    invalid: PropTypes.bool.isRequired,
    onBack: PropTypes.func,
    onContinue: PropTypes.func,
    prefix: PropTypes.array,
    suffix: PropTypes.array
};

export default compose(
    connect((state, props) => ({
        initialValues: {
            usCitizen: true,
            hasStateLicense: true,
            getUpdates: true,
            dateOfBirth: props.dateOfBirth,
            prefix: props.prefix.includes(state.cachedFormData.prefix)
                ? state.cachedFormData.prefix
                : '',
            firstName: getCachedFirstName(state),
            middleName: getCachedMiddleName(state),
            lastName: getCachedLastName(state),
            suffix: props.suffix.includes(state.cachedFormData.suffix)
                ? state.cachedFormData.suffix
                : '',
            email: state.cachedFormData.email || ''
        },
        currentFormValues: (state.form['voteRegistrationStep1Form'] || {}).values
    })),
    reduxForm({
        form: 'voteRegistrationStep1Form',
        destroyOnUnmount: false,
        validate
    })
)(VoteRegistrationStep1Form);
